import React, { createContext, useContext, useEffect, useState } from "react";

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [activeModals, setActiveModals] = useState(0);

  const registerModal = isOpen => {
    setActiveModals(current => current + (isOpen ? 1 : -1));
  };

  useEffect(() => {
    if (activeModals > 0) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [activeModals]);

  return (
    <ModalContext.Provider value={{ registerModal }}>
      {children}
    </ModalContext.Provider>
  );
};
